import axiosClient from './axiosClient';

export const getUserProfile = async () => {
    try {
        const response = await axiosClient.get('/v1/user/profile');
        return response.data;
    } catch (error) {
        return {
            success: false,
            error: true,
            message: error.message
        };
    }
};

export const updateUserProfile = async (profileData) => {
    try {
        const response = await axiosClient.post('/v1/user/profile/complete', profileData);
        return response.data;
    } catch (error) {
        return {
            success: false,
            error: true,
            message: error.response?.data?.data?.message || error.message
        };
    }
}; 

export const getUserNotifCount = async () => {
    try {
        const response = await axiosClient.get('v1/user/notifications/count')
        return response.data;
    }
    catch (error) {
        return {
            success: false,
            error: true,
            message: error.message
        }
    }
}

export const getUserNotifs = async () => {
    try {
        const response = await axiosClient.post('v1/user/notifications')
        return response.data;
    }
    catch (error) {
        return {
            success: false,
            error: true,
            message: error.message
        }
    }
}